import React, { useEffect, useState } from "react";
import "./withdraw_tax_info.scss";
import Devider from "Shared/ui/devider";
import PropTypes from "prop-types";

export const WithdrawTaxInfo = ({ taxPercent, inputAmount, calculated }) => {
	const [renderCalculated, setRenderCalculated] = useState(undefined);
	useEffect(() => {
		if (calculated != undefined) {
			setRenderCalculated(calculated);
		} else {
			setRenderCalculated({
				tax_percent: taxPercent,
				request_amount: inputAmount,
				net_amount: ((inputAmount / 100) * (100 - taxPercent)).toFixed(2),
				tax_amount: ((inputAmount / 100) * taxPercent).toFixed(2),
			});
		}
	}, [calculated, taxPercent, inputAmount]);
	return (
		<div className="tax-info">
			<Devider />
			<div className="row">
				<div>{`Income tax ${renderCalculated?.tax_percent}%`}</div>
				<div>{`${renderCalculated?.tax_amount} €`}</div>
			</div>
			<Devider />
			<div className="row">
				<div>{"Net money prize"}</div>
				<div>{`${renderCalculated?.net_amount} €`}</div>
			</div>
			<Devider />
		</div>
	);
};

WithdrawTaxInfo.propTypes = {
	taxPercent: PropTypes.number,
	inputAmount: PropTypes.number,
	calculated: PropTypes.shape({
		net_amount: PropTypes.number,
		request_amount: PropTypes.number,
		tax_amount: PropTypes.tax_amount,
		tax_percent: PropTypes.tax_percent,
	}),
};
